import React from "react";
import MDEditor, { commands } from "@uiw/react-md-editor";
import { Box, Typography } from "@mui/material";

interface MarkdownEditorProps {
  value: string;
  onChange: (value: string) => void;
  label?: string;
}

export const MarkdownEditor: React.FC<MarkdownEditorProps> = ({
  value,
  onChange,
  label,
}) => {
  return (
    <Box sx={{ m: "1rem" }}>
      {label && (
        <Typography variant="body2" color="textSecondary" sx={{ mb: 1 }}>
          {label}
        </Typography>
      )}
      <div data-color-mode="light">
        <MDEditor
          value={value}
          onChange={(val) => onChange(val ?? "")}
          commands={[
            commands.bold,
            commands.italic,
            commands.strikethrough,
            commands.hr,
            commands.divider,
            commands.title1,
            commands.title2,
            commands.title3,
            commands.divider,
            commands.link,
            commands.quote,
            commands.code,
            commands.codeBlock,
            commands.divider,
            commands.unorderedListCommand,
            commands.orderedListCommand,
            commands.checkedListCommand,
          ]}
          extraCommands={[
            commands.codeEdit,
            commands.codeLive,
            commands.codePreview,
          ]}
          height={200}
        />
      </div>
    </Box>
  );
};
